export default "__VITE_ASSET__O6UT7YUT__"